module.exports = __webpack_public_path__ + "static/media/visual-merchandising.8f1920fd.png";